import { render } from "./PedidoDetalheView.vue?vue&type=template&id=57bf9e74&scoped=true"
import script from "./PedidoDetalheView.vue?vue&type=script&lang=js"
export * from "./PedidoDetalheView.vue?vue&type=script&lang=js"

import "./PedidoDetalheView.vue?vue&type=style&index=0&id=57bf9e74&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bf9e74"]])

export default __exports__